import { Component, inject } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MenuStore } from './menu.store';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GreetingComponent } from '../greeting/greeting.component';

@Component({
  selector: 'debtor-panel-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    MatListModule,
    MatSidenavModule,
    CommonModule,
    RouterModule,
    GreetingComponent,
  ],
})
export class MenuComponent {
  protected fontSize = 10;
  protected readonly store = inject(MenuStore);
  protected isMobileMenuOpen = false;

  protected logout(event: Event) {
    event.preventDefault();
    this.store.logout();
  }

  protected showData(): void {
    this.store.goToUserDetails();
  }

  protected toggleMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  protected returnToDashboard(event: Event): void {
    event.preventDefault();
    this.store.returnToDashboard();
  }

  protected changePassword(): void {
    this.store.changePassword();
  }

  protected IncreaseFontSize(): void {
    if(this.fontSize < 30) {
      this.fontSize += 2;
      document.documentElement.style.setProperty(
        '--smallest-font',
        `${this.fontSize}px`,
      );
      document.documentElement.style.setProperty('--smallest-font', `${this.fontSize}px`);
    }
  }

  protected DecreaseFontSize(): void {
    if(this.fontSize > 10) {
      this.fontSize -= 2;
      document.documentElement.style.setProperty(
        '--smallest-font',
        `${this.fontSize}px`,
      );
    }
  }
}
